<template>
	<el-row class="about_aminOne_box">
		<el-row class="about_aminOne_box_t">
			<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item>PRODUCT</el-breadcrumb-item>
			<el-breadcrumb-item :to="product_route">{{product_title}}</el-breadcrumb-item>
			<el-breadcrumb-item>{{productListData.title}}</el-breadcrumb-item>
			</el-breadcrumb>
		</el-row>
		<el-row class="about_aminOne_box_title" >
			<img src="@/assets/image/product/PRODUCTDETAIS.png" alt="">
		</el-row>
		<el-row class="main_3" v-if="productListData" >
			<el-row class="main_3_l">
				<!-- <img src="@/assets/image/product/HZ-S4010.jpg" alt=""> -->
				<img :src="productListData.url" alt="">
			</el-row>
			<el-row class="main_3_r">
				<el-row class="main_3_r_box"><span class="main_3_r_l" >Code:</span> <span class="main_3_r_r">{{productListData.title}}</span></el-row>
				<el-row class="main_3_r_box"><span class="main_3_r_l" >Size:</span> <span class="main_3_r_r">{{productListData.list1}}</span></el-row>
				<el-row class="main_3_r_box"><span class="main_3_r_l" >Material:</span> <span class="main_3_r_r">{{productListData.list2}}</span></el-row>
				<el-row class="main_3_r_box"><span class="main_3_r_l" >Pattern:</span> <span class="main_3_r_r">{{productListData.list3}}</span></el-row>
				<el-row class="main_3_r_box"><span class="main_3_r_l" >Finish:</span> <span class="main_3_r_r">{{productListData.list4}}</span></el-row>
				<el-row class="main_3_r_box"><span class="main_3_r_l" >Style:</span> <span class="main_3_r_r">{{productListData.list5}}</span></el-row>
				<el-row class="main_3_r_box"><span class="main_3_r_l" >Brand:</span> <span class="main_3_r_r">{{productListData.list6}}</span></el-row>
				<el-row class="main_3_r_box"><span class="main_3_r_l" >Function:</span> <span class="main_3_r_r">{{productListData.list7}}</span></el-row>
				<el-row class="main_3_r_box"><span class="main_3_r_l" >Slip rating:</span> <span class="main_3_r_r">{{productListData.list8}}</span></el-row>
				<el-row class="main_3_r_box"><span class="main_3_r_l" >Sales model:</span> <span class="main_3_r_r">{{productListData.list9}}</span></el-row>
				<el-row class="main_3_r_box">
					<a href="mailto:sales@hezonetile.com"><img src="@/assets/image/product/contactus.png" alt=""></a>
				</el-row>
			</el-row>

		</el-row>
		<el-row class="about_aminOne_box_title" >
			<img src="@/assets/image/product/OPTIONALSURFACEPATTERN.png" alt="">
		</el-row>
		<el-row class="main_4">
			<el-row class="main_4_list colorone">Spiricle</el-row>
			<el-row class="main_4_list colortwo">Mill finish</el-row>
			<el-row class="main_4_list colorthree">Diamond / sunflower</el-row>
			<el-row class="main_4_list colorone">Concentric circles with step</el-row>
			<el-row class="main_4_list colortwo">Concentric circles on surface</el-row>
			<el-row class="main_4_list_none"></el-row>
			<el-row class="main_4_list_none"></el-row>
			<el-row class="main_4_list_none"></el-row>
			<el-row class="main_4_list_none"></el-row>
		</el-row>
		<el-row class="about_aminOne_box_title" >
			<img src="@/assets/image/product/TYPEOFPACKAGES.png" alt="">
		</el-row>
		<el-row class="main_5">
			<el-row class="main_5_list"><img src="@/assets/image/product/inbulk.jpg" alt="">
			<span class="main_5_list_span">IN BULK</span>
			</el-row>
			<el-row class="main_5_list"><img src="@/assets/image/product/byfoam.jpg" alt="">
				<span class="main_5_list_span">BR FOAM</span>
			</el-row>
			<el-row class="main_5_list"><img src="@/assets/image/product/woodenCase.jpg" alt="">
				<span class="main_5_list_span">PALLET</span>
			</el-row>
			<el-row class="main_5_list"><img src="@/assets/image/product/pallet.jpg" alt="">
				<span class="main_5_list_span">WOODEN CASE</span>
			</el-row>
			<el-row class="main_5_list_none"></el-row>
			<el-row class="main_5_list_none"></el-row>
		</el-row>
	</el-row>
</template>

<script>
	export default {
		components: {
			// banner:banner,
		},
		data() {
			return {
				imgdata:[
					{url:require('@/assets/image/home/AntislipStrip.png'),text:'Anti-slip Strip'},
				],
				idIndex:null,//列表索引
				imgDatalis:null,//从哪儿进来的
				productListData:null,//要渲染的数据
				product_route:null,//路由
				product_title:null,//产品分类名称
			}
		},
		created() {
			this.getData()
		},
		methods: {
			getData(){
				this.idIndex=this.$route.query.id;
				this.imgDatalis=this.$route.query.imgDataIndex;
				let data=JSON.parse(sessionStorage.getItem("imgData"+this.imgDatalis))[this.idIndex];
				this.productListData=data;
				// sessionStorage.setItem('imgData'+this.imgDatalis,JSON.stringify(this.imgdata))
				
				this.imgDatalis==1?this.product_route={ path: '/productAntiSilpStrip'}:'';
				this.imgDatalis==1?this.product_title="Anti-slip Strip":'';
				this.imgDatalis==2?this.product_route={ path: '/productTactileIndicator'}:'';
				this.imgDatalis==2?this.product_title="Tactile Indicator":'';
				this.imgDatalis==3?this.product_route={ path: '/productStairNosing'}:'';
				this.imgDatalis==3?this.product_title="Stair Nosing":'';
				this.imgDatalis==4?this.product_route={ path: '/productTactilePaving'}:'';
				this.imgDatalis==4?this.product_title="Tactile Paving":'';
				this.imgDatalis==5?this.product_route={ path: '/productFRPProducts'}:'';
				this.imgDatalis==5?this.product_title="FRP Product":'';
				this.imgDatalis==6?this.product_route={ path: '/productAccessories'}:'';
				this.imgDatalis==6?this.product_title="Accessories":'';
				
			},
		},
	
	}
</script>

<style lang="less" scoped>
	@vw: 19.2vw;

	.about_aminOne_box {
		background: url(~@/assets/image/home/home_bg1.jpg);
		padding: 0 2vw;
		padding-top: 30/@vw;
		padding-bottom: 100/@vw;
		box-sizing: border-box;
		color: #b28847;
		.about_aminOne_box_t{
			width:100%;
			max-width: 1200px;
			margin: 0 auto;
			margin-top: 80/@vw;
			/deep/ span{
				font-size: 24/@vw;
			}
		}
		.about_aminOne_box_title{
			width:100%;
			max-width: 1200px;
			margin: 0 auto;
			margin-top: 50/@vw;
			img{
				min-width: 218px;
				min-height: 25px;
			}
		}
		.main_3 {
			width:100%;
			max-width: 1200px;
			margin: 0 auto;
			margin-top: 40/@vw;
			display: flex;
			justify-content: center;
			flex-direction: row;
			flex-wrap: wrap;
			.main_3_l {
					width: 520/@vw;
					height: 520/@vw;
					min-width: 300px;
					min-height: 300px;
					img{
						width: 100%;
						height: 100%;
					}
					margin-bottom: 20/@vw;
			}
			.main_3_r {
				max-width: 600px;
				min-width: 300px;
				padding-left: 2vw;
				box-sizing: border-box;
				margin-top: 20/@vw;
				.main_3_r_box{
					margin-top: 20/@vw;
					.main_3_r_l{
						font-weight: 700;
						color: #1a1a1a;
						font-size: 18/@vw;
						display: inline-block;
						width: 120px;
					}
					.main_3_r_r{
						color: #1a1a1a;
						font-size: 18/@vw;
					}
				}
		
			}
		}
		.main_4{
			width:100%;
			max-width: 1350px;
			margin: auto;
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: row;
			flex-wrap: wrap;
			.main_4_list{
				width: 224px;
				height: 112px;
				border-radius: 10px;
				font-size: 20/@vw;
				display: flex;
				align-items: center;
				justify-content: center;
				margin: 20/@vw;
				padding: 0 7px;
				font-weight: 700;
				box-sizing: border-box;
			}
			.colorone{
				background-color: #d9d9d9;
				color: #1b1b1b;
			}
			.colortwo{
				background: url(~@/assets/image/product/pro_bg3.png);
				color: #fff;
			}
			.colorthree{
				background-color: #fff;
				color: #232323;
			}
			.main_4_list_none{
				width: 224px;
				height: 0;
				margin: 20/@vw;
			}
		}
		.main_5{
			width:100%;
			max-width: 1350px;
						margin: auto;
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: row;
			flex-wrap: wrap;
			.main_5_list{
				width: 285px;
				height: 285px;
				font-size: 20/@vw;
				display: flex;
				align-items: center;
				justify-content: center;
				margin: 20/@vw;
				position: relative;
				.main_5_list_span{
					height: 44px;
					width: 100%;
					position: absolute;
					left: 0;
					bottom: 0;
					color: #fafafa;
					background-color: rgba(51,51,51,0.6);
					display: flex;
					align-items: center;
					justify-content: center;
					font-size: 18/@vw;
				}
			}
			.main_5_list_none{
				width: 285px;
				height: 0;
				margin: 20/@vw;
			}
		}
		
	
	
	}

</style>
